import React, { ComponentProps } from 'react';
import { Form } from 'antd';
import { CurrencyInput } from '@common/components';

type Props = {
  name: string;
  label: JSX.Element;
  incentivePriceIncrements?: number;
  required?: boolean;
  // Workaround because the JS type is incorrect inferred
  onClear?: () => void;
  increment?: number;
  validateIncrement: boolean;
} & Omit<ComponentProps<typeof CurrencyInput>, 'onClear'>;

export function RateCurrencyInput({
  required,
  name,
  label,
  increment,
  validateIncrement = false,
  onClear,
  ...props
}: Props) {
  function validateIsMultipleOfIncrement(
    _: unknown,
    value: number
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      if (!value || !increment || !validateIncrement) return resolve();

      const multipleToAvoidModOfDecimals = 10000;

      const isValueMultipleOfIncrement =
        (value * multipleToAvoidModOfDecimals) %
          (increment * multipleToAvoidModOfDecimals) ===
        0;

      if (isValueMultipleOfIncrement) {
        resolve();
      } else {
        reject(true);
      }
    });
  }

  return (
    <Form.Item
      rules={[
        { required, message: 'Insert a value' },
        {
          validator: validateIsMultipleOfIncrement,
          message: `Must be multiple of ${increment}`,
        },
      ]}
      name={name}
      label={label}
    >
      <CurrencyInput max={250} step={increment} onAction={onClear} {...props} />
    </Form.Item>
  );
}
